angular.module('signalview.snapshotSharing', [
    'sfx.api.v2',
    'signalview.sharing',
    'signalview.dashboardUtil',
    'signalview.utils',
]);
